module.exports = __webpack_public_path__ + "media/images/vk-92ee71e43a9bcc80c25f6485353e430f.png";